import {lazy, Suspense} from "react"
import Loader from "../custom/loader/main"

const Main = lazy(() => import("../components/merchants/forms/editUser"))

const EditUser = () => {
  return (
    <Suspense fallback={<Loader />}>
        <Main />
    </Suspense>
  )
}

export default EditUser